import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const PageNotFound = () => {
  const { t } = useTranslation();


  const routeToHome = () => {
    window.location.href = '/'
  }
  return (
    <>
      {/* <main class="h-screen w-full flex flex-col justify-center items-center bg-white">
	<h1 class="text-9xl font-extrabold text-customgreen tracking-widest">404</h1>
	<div class="bg-[#F59E0B] flex justify-center h-5 w-56 px-2 text-sm rounded rotate-12 absolute">
		<h2 className="font-bold text-white ">Page Not Found</h2>
	</div>
	<button class="mt-5">
      <a
        class="relative hover:text-white inline-block rounded-full text-sm font-medium text-white group active:text-orange-500 focus:outline-none focus:ring"
      >
        <span
          class="absolute inset-0 rounded-full transition-transform translate-x-0.5 translate-y-0.5 bg-[#F59E0B] group-hover:translate-y-0 group-hover:translate-x-0"
        ></span>

        <span class="relative hover:text-white rounded-full block px-8 py-2 bg-customgreen border border-current">
          <Link className="rounded-full hover:text-white" to="/">Go Home</Link>
        </span>
      </a>
    </button>
</main> */}
      <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 px-2 lg:px-5">
        <h1 className="text-6xl font-bold text-customgreen">404</h1>
        <h2 className="text-3xl mt-4 font-semibold text-gray-800">{ t("Page Not Found") }</h2>
        <p className="mt-2 text-gray-600 text-lg text-center">
          { t("Sorry, the page you are looking for does not exist or has been moved.") }
        </p>
        <div className="mt-6 flex gap-2">

          <button
            onClick={ () => history.back() }

            className="px-6 flex gap-2 items-center transition-all duration-500 ease-in-out py-2 bg-white text-customgreen rounded-full shadow-md hover:bg-customgreen "
          >  { t("Go Back") }
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 ">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
            </svg>
          </button>
          <button
            onClick={ routeToHome }
            className="px-6  transition-all duration-500 ease-in-out py-2 bg-customgreen text-white rounded-full shadow-md hover:bg-hovergreen"
          >
            { t("Back To Home") }
          </button>

        </div>
      </div>
    </>
  );
};

export default PageNotFound;